<template>
  <div class="bg-gray">
    <div class="form-content">
      <el-form
          :model="formData"
          ref="ruleForm"
          label-width="120px"
          class="demo-ruleForm"
      >

        <el-form-item label="证件照片" prop="grade">
          <PicUploader :fileList="formData.pic" :limit="1"></PicUploader>
          <div class="form-label-desc">请上传符合正式规范的2寸证件照，蓝底、白底、灰底均可</div>
          <div class="notice-box mt10">{{formData.status == 3 ? formData.admin_note : '证件照正在审核中，人工审核中预计7天，审核通过后，可以再次下载证书哦~'}}</div>

        </el-form-item>

        <el-row>
          <el-col class="footer-button">
            <el-button type="primary" @click="onSubmit" :loading="saveLoading">{{formData.pic.length > 0 ? '修改' : '保存'}}
            </el-button>
            <!--            <el-button @click="resetForm('ruleForm')" plain>重置</el-button>-->
          </el-col>
        </el-row>
      </el-form>
  </div>
  </div>
</template>
<style scoped>
.box {
  /*margin-bottom: 1.5rem;*/
}

.savebtn {
  position: fixed;
  bottom: 0;
  padding-bottom: 0.2rem;
  width: 100%;
  z-index: 10;
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: space-around;
  background: linear-gradient(180deg, hsla(0, 0%, 100%, 0), #fff);
}


.van-tag {
  width: 55px;
  margin-left: 10px;
  text-align: center;
}

.between {
  justify-content: space-between;
}


</style>
<script>
import Vue from 'vue';
import area from "../../../utils/area";
import namekey from "../../../utils/namekey";
import validator from "../../../utils/validator";
import PicUploader from '@/components/picker/PicUploader.vue';

import {
  Cell,
  Field,
  Area,
  Form,
  Divider,
  CellGroup,
  RadioGroup,
  Radio,
  Icon,
  Toast,
  Popup,
  Picker,
  Sidebar,
  SidebarItem,
  Tag,
  Stepper,
  Switch,
  Button
} from 'vant';

Vue.use(Cell).use(CellGroup).use(Form).use(Divider).use(Area).use(RadioGroup).use(Radio).use(Icon).use(Toast).use(Popup).use(Picker).use(Sidebar).use(SidebarItem).use(Tag).use(Stepper).use(Field)
    .use(Switch).use(Button);
export default {
  name: 'CertPersonPhoto',
  components: {
    PicUploader,
  },
  data: function () {
    return {
      validator,
      saveLoading: false,
      showArea: false,
      showNamekey: false,
      areaList: {},
      namekeyList: {},
      areaValue: '',
      submitType: '',
      formData: {
        id: 0,
        num: '',
        pic: [] // [{"uid":"vc-upload-1587109262602680","url":"https://cheeseman.oss-cn-hangzhou.aliyuncs.com/h5/2020-04-17/1587109262602680.jpg","name":"支付宝.jpg","save_name":"h5/2020-04-17/1587109262602680.jpg"},{"uid":"vc-upload-1587109262602680","url":"https://cheeseman.oss-cn-hangzhou.aliyuncs.com/h5/2020-04-17/1587109262602680.jpg","name":"支付宝.jpg","save_name":"h5/2020-04-17/1587109262602680.jpg"}],
      },
    }
  },
  filters: {},
  mounted() {
    let that = this;
    document.title = "证件照管理"
    that.fetch()
  },
  watch: {
  },
  destroyed() {
  },
  methods: {

    onSubmit(values) {
      console.log('onSubmit-values', values);
      console.log('submitType', this.submitType);

      let that = this;
      console.log(that.formData)
      that.formValidate = true;
      for (let field in that.formData) {

        if (!this.formData.pic.length) {
          that.$message.warning('请选择证件照片');
          return
        }
      }
      that.saveLoading = true;

      that.$api.post('/api/user/photoSubmit', that.formData, (res) => {
        that.saveLoading = false;
        that.$message.success('保存成功')
        setTimeout(function(){
          rbLink({
            name: 'MyExperience',
            query: {
            }
          });
        },500);
      }, (res) => {
        that.$message.warning(res.msg);
        that.saveLoading = false;
      })
    },
    save(values) {
      this.submitType = 'save';
    },

    submit(values) {
      this.submitType = 'submit';
    },
    fetch() {
      let that = this;
      that.$api.post('/api/user/photoData', {}, (res) => {
        that.formData = res.data;
      }, (res) => {

//                    Toast.fail(res.msg);
      })
    }

  }
}
</script>



// WEBPACK FOOTER //
// CertPersonPhoto.vue?b3525832